/**
 * groups actions
 */
import {
    GROUP_CREATE_REQUESTED,
    GROUP_CREATE_SUCCEEDED,
    GROUP_CREATE_FAILED,
    GROUP_UPDATE_REQUESTED,
    GROUP_UPDATE_SUCCEEDED,
    GROUP_UPDATE_FAILED,
    GROUP_DELETE_REQUESTED,
    GROUP_DELETE_SUCCEEDED,
    GROUP_DELETE_FAILED
} from './constants';

export function createGroup(data) {
    return {
        type: GROUP_CREATE_REQUESTED,
        data,
        meta: {
            logentries: true
        }
    };
}

export function groupCreated(response) {
    return {
        type: GROUP_CREATE_SUCCEEDED,
        response,
        payload: response,
        meta: {
            schemaName: 'group'
        }
    };
}

export function failedCreateGroup(error: Error) {
    return {
        type: GROUP_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function editGroup(id, data) {
    return {
        type: GROUP_UPDATE_REQUESTED,
        id,
        data,
        meta: {
            logentries: true
        }
    };
}

export function groupEdited(id, response) {
    return {
        type: GROUP_UPDATE_SUCCEEDED,
        id,
        response,
        payload: response,
        meta: {
            schemaName: 'group'
        }
    };
}

export function failedEditGroup(error: Error) {
    return {
        type: GROUP_UPDATE_FAILED,
        payload: error,
        error: true
    };
}

export function deleteGroup(id) {
    return {
        type: GROUP_DELETE_REQUESTED,
        id,
        meta: {
            logentries: true
        }
    };
}

export function groupDeleted(id, response) {
    return {
        type: GROUP_DELETE_SUCCEEDED,
        id,
        response
    };
}

export function failedDeleteGroup(error: Error) {
    return {
        type: GROUP_DELETE_FAILED,
        payload: error,
        error: true
    };
}
